
export default {
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    headingTitle () {
      if (this.title) {
        return this.title;
      } else if (this.post?.acf?.page_title_override) {
        return this.post.acf.page_title_override;
      } else if (this.post) {
        const titleOverrides = this.siteSettings.page_title_overrides;
        for (const override of titleOverrides) {
          if ([...override.post_types].find(type => type === this.post.type)) {
            return override.title_override;
          }
        }
      }

      return this.post.title;
    },
    linkedSponsor () {
      return this.$store.state.config.sponsored_pages;
    },
  },
};
